import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Feedback } from "../../interfaces/feedback";
import { environment } from "../../../environments/environment";

@Injectable()
export class FeedbackService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  saveFeedback(feedback: Feedback): Promise<any> {
    return this.http
      .post<any>(this.env.managirUrl + "/feedback", feedback, {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/feedback/feedback.service.ts